import { yupResolver } from '@hookform/resolvers/yup';
import { Report, ReportOff } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, Grid, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { DialogForm, FooterDialogActions, TextFieldApp } from 'shared/components';
import { IFormClient } from 'shared/dtos';

import { defaultValuesClientEdit, fieldsClient, schemaClient } from '../../../utils';
import { stylesIcon } from './styles';
import { DialogEditProps } from './types';

export function DialogEdit({
  client,
  onSubmitUpdate,
  open,
  handleClose,
  loading,
}: DialogEditProps) {
  const {
    handleSubmit,
    control,
    formState: { isValid, isDirty },
  } = useForm<IFormClient>({
    resolver: yupResolver(schemaClient),
    defaultValues: defaultValuesClientEdit(client),
  });

  const [disabledState, setDisabledState] = useState(true);
  const [showModalAlert, setShowModalAlert] = useState(false);

  const onToggleModalAlert = () => setShowModalAlert(prev => !prev);
  const onToggleDisabledState = () => setDisabledState(prev => !prev);

  return (
    <>
      <DialogForm
        open={open}
        onClose={handleClose}
        loading={loading}
        onSubmit={handleSubmit(onSubmitUpdate)}
        title="EDITAR CLIENTE"
        disabled={!isDirty || !isValid}
      >
        <Grid item xs={12}>
          <TextFieldApp
            name={fieldsClient.NAME}
            control={control}
            label="Nome do cliente"
            required
            disabled={loading}
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldApp
            name={fieldsClient.DEBIT}
            control={control}
            label="Dívida do cliente"
            currency
            disabled={loading || disabledState}
            renderRight={
              disabledState ? (
                <Tooltip title="Atenção, ao alterar a dívida do cliente diretamente, pode causar inconsistências nos valores">
                  <ReportOff onClick={onToggleModalAlert} style={stylesIcon} />
                </Tooltip>
              ) : (
                <Report onClick={onToggleDisabledState} style={stylesIcon} />
              )
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldApp
            name={fieldsClient.PHONE}
            control={control}
            label="Telefone"
            type="tel"
            mask="(00) 00000-0000"
            disabled={loading}
          />
        </Grid>
      </DialogForm>

      <Dialog open={showModalAlert} onClose={onToggleModalAlert}>
        <DialogTitle>Atenção</DialogTitle>
        <DialogContent>
          Ao alterar a dívida do cliente diretamente, pode causar inconsistências nos valores
        </DialogContent>
        <FooterDialogActions
          textButtonConfirm="OK"
          textButtonCancel="CANCELAR"
          onClose={onToggleModalAlert}
          isDialogDelete
          onSubmitDelete={() => {
            onToggleModalAlert();
            onToggleDisabledState();
          }}
          loading={false}
        />
      </Dialog>
    </>
  );
}
